/**
 * Returns the current year.
 * If the optional parameter `abbreviated` is set to true, returns the last two digits of the year.
 * @param {boolean} [abbreviated=false] - Whether to return the abbreviated year.
 * @returns {number|string} The current year or its last two digits.
 */
export const getCurrentYear = (abbreviated?: boolean) => {
  const currentYear = new Date().getFullYear();
  return abbreviated ? currentYear % 100 : currentYear;
};
